import React from 'react';

//Alternative to <div> in the "return()" - sometime we dont want to use a HTML <div> (it can even interfer if you are using Flexbox) 
const aux = (props) => props.children;

export default aux;



// WEBPACK FOOTER //
// src/hoc/Aux_file.js